import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LoggerService } from 'services/LoggerService';
import { conf } from 'config';
import { translations } from 'i18n/translations';

const logger = LoggerService.getLogger('i18n');

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: conf.defaultLanguage,
    fallbackLng: 'en_US',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    logger.info('i18n Started.');
  })
  .catch(() => {
    logger.error('Failed to load i18n');
  });

export default i18n;
